<div class="flex w-full">
    @if (editMode) {
    <div class="flex flex-col border-b mb-4 pt-4 pb-2 pl-2 min-w-1/2" (dragover)="onDragOver($event)"
        (drop)="onDrop($event)">
        <ng-container>
            <input type="file" class="file-input" [accept]="accept" [multiple]="multiple"
                (change)="onFilesSelected($event)" [formControl]="formControl" [formlyAttributes]="field" #matUpload>

            <div class="flex flex-row items-center file-upload upload-drop-zone" (dragover)="onDragOver($event)"
                (drop)="onDrop($event)" [class.dragging]="isDragging" (click)="matUpload.click()">
                <button type="button" mat-mini-fab color="primary" class="upload-btn">
                    <mat-icon class="icon-size-5">attach_file</mat-icon>
                </button>
                <span class="upload-btn">
                    <mat-label>{{label}}</mat-label>
                    @if(fieldSize){
                    <div class="text-secondary font-semibold text-sm">
                        @if (fmaxFieldSizeAllegati){
                            {{allegati.length}} file dimensione {{fieldSize | bytes}} SU {{maxFieldSizeAllegati | bytes}}
                        }@else{
                            {{allegati.length}} file dimensione {{fieldSize | bytes}}
                        }
                        <!--
                        <div class="text-secondary font-semibold">
                            TOTALE: {{totalSize | bytes}} su {{maxTotSizeAllegati | bytes}}
                        </div>-->
                    </div>
                    }
                </span>
            </div>
        </ng-container>
        <formly-validation-message [field]="field" class="text-red-600"></formly-validation-message>
        <!--allegati in fase di caricamento-->
        <ul class="flex flex-col gap-y-1.5">

            @for(allegato of files; track allegato.id; let i = $index){
                @if(allegato.progress$ | async; as progress){
                    @if(progress < 100){
                    <div class="list-file-upload mb-3.5">
                        <li class="flex items-center justify-between">
                            <!-- {{allegato.cancelled?'cancellato!!!!!!!!!!!!!!':'in caricamento......'}} -->
                            <!-- Sezione principale con icone e informazioni -->
                            <div class="flex items-start gap-x-1.5">
                                @if (allegato.descrizione){
                                    {{ allegato.descrizione }} ({{ allegato.file_name }}) ({{ allegato.file_size
                                    | bytes }})
                                }@else{
                                    {{ allegato.file_name }} ({{ allegato.file_size | bytes }})
                                }
                                {{allegato.cancelled?'File cancellato':'File in caricamento'}}
                            </div>
                            <div class="upload-progress">
                                <div class="flex flex-row w-full">
                                    <mat-progress-bar [value]="progress"></mat-progress-bar>
                                </div>
                                <button type="button" mat-icon-button [attr.aria-label]="'cancelAriaLabel'"
                                    (click)="stopUpload(allegato)">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                                <span class="file-summary">{{ progress }}%</span>
                            </div>
                        </li>
                    </div>
                }}
                @if(allegato.error){
                <div class="flex flex-row items-center mt-2 p-2 bg-red-50 text-red-600">
                    <div class="flex items-start gap-x-1.5">
                        <mat-icon class="text-red-500 mr-1 align-middle">error_outline</mat-icon>
                        {{ allegato.file_name }} - Errore: {{ allegato.error_message }}
                    </div>
                </div>
                }
            }
        </ul>
        <ng-container *ngTemplateOutlet="allegatiEsistenti"></ng-container>
        @for(item of uploadErrors; track item){
            {{item}}
        }
    </div>
    }@else{
        <div class="flex flex-col border-b mb-2 pt-4 pb-2 pl-2 min-w-1/2">
            <div class="flex flex-row mb-2"> <mat-icon svgIcon="file_present"></mat-icon>{{label}}</div>
            <ng-container *ngTemplateOutlet="allegatiEsistenti"></ng-container>
        </div>
    }


    <ng-template #allegatiEsistenti>
        <!--allegati caricati in precedenza-->
        <ul class="flex flex-col gap-y-1.5 disabled-text">
            @for(allegato of allegati; track allegato.id; let i = $index){
                @if(!allegato.file){
                <li class="flex items-center justify-between">
                    <!-- Sezione principale con icone e informazioni -->
                    <div class="flex items-center gap-x-1.5">
                        <!-- Icona "launch" -->
                        <mat-icon class="cursor-pointer" (click)="apriFile(allegato)">
                            launch
                        </mat-icon>
                        <!-- Testo dell'allegato -->
                        <span (click)="apriFile(allegato)" class="cursor-pointer">
                            @if (allegato.descrizione){
                                {{ allegato.descrizione }} ({{ allegato.file_name }}) ({{ allegato.file_size
                                | bytes }})
                            }@else{
                                {{ allegato.file_name }} ({{ allegato.file_size | bytes }})
                            }
                        </span>
                    </div>
                    <!-- stessa colonna -->
                    <div>
                        @if (formState.editMode) {
                        <mat-icon class="cursor-pointer icon-size-5" (click)="scaricaFile(allegato)"
                            [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <mat-icon class="cursor-pointer icon-size-5 ml-2" (click)="onDelete(allegato)"
                            [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                        }
                    </div>
                </li>
                }
            }
        </ul>
    </ng-template>

</div>
